import * as THREE from "three";
import { safeShaderReplace } from "../shaderUtils";

const ORIGINAL_CONDITION =
  "#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )";
const REPLACEMENT_CONDITION =
  "#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) || defined( SUPPORT_HEIGHT_LAYERS ) )";

/**
 * GLSL code based on and intended to replace the three.js "normalmap_pars_fragment" shader chunk.
 * We include the helper function in case SUPPORT_HEIGHT_LAYERS is enabled.
 */
export const normalmapParsFragmentChunk = safeShaderReplace(
  THREE.ShaderChunk["normalmap_pars_fragment"],
  ORIGINAL_CONDITION,
  REPLACEMENT_CONDITION,
  "normalmapParsFragment",
);
